export const handlePress =
  (fn, ...args) =>
  () =>
    fn && fn(...args);
